import styled from 'styled-components'

export const StyledTextImageAdmin = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 1rem;
`

export const StyledTwoText = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
`
export const StyledText = styled.div`
  width: 50%;
`
